(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lootdrop-account"]) return;
  try {
    
(function () {
  var root = document.querySelector('.ld-account');
  if (!root) return;

  // ---------- Login: toggle recover password panel ----------
  var showRecover = root.querySelector('#ldShowRecover');
  var hideRecover = root.querySelector('#ldHideRecover');
  var loginPanel = root.querySelector('#ldLoginPanel');
  var recoverPanel = root.querySelector('#ldRecoverPanel');

  function setRecoverVisible(visible) {
    if (!loginPanel || !recoverPanel) return;
    if (visible) {
      loginPanel.setAttribute('hidden', '');
      recoverPanel.removeAttribute('hidden');
      var input = recoverPanel.querySelector('input[type="email"]');
      if (input) input.focus();
    } else {
      recoverPanel.setAttribute('hidden', '');
      loginPanel.removeAttribute('hidden');
    }
  }

  if (showRecover) {
    showRecover.addEventListener('click', function (e) {
      e.preventDefault();
      setRecoverVisible(true);
    });
  }
  if (hideRecover) {
    hideRecover.addEventListener('click', function (e) {
      e.preventDefault();
      setRecoverVisible(false);
    });
  }

  // Open recover panel on page load if URL hash is #recover, or after a failed/successful recover submission
  if (location.hash === '#recover' || (recoverPanel && recoverPanel.querySelector('.ld-form-banner'))) {
    setRecoverVisible(true);
  }

  // ---------- Addresses: toggle new-address form ----------
  var showNew = root.querySelector('#ldShowNewAddress');
  var hideNew = root.querySelector('#ldHideNewAddress');
  var newPanel = root.querySelector('#ldNewAddressPanel');

  function setNewVisible(visible) {
    if (!showNew || !newPanel) return;
    if (visible) {
      newPanel.removeAttribute('hidden');
      showNew.setAttribute('aria-expanded', 'true');
      var first = newPanel.querySelector('input, select');
      if (first) first.focus();
    } else {
      newPanel.setAttribute('hidden', '');
      showNew.setAttribute('aria-expanded', 'false');
    }
  }

  if (showNew) {
    showNew.addEventListener('click', function () {
      var open = showNew.getAttribute('aria-expanded') === 'true';
      setNewVisible(!open);
    });
  }
  if (hideNew) {
    hideNew.addEventListener('click', function () {
      setNewVisible(false);
    });
  }

  // Auto-open the new-address panel if it contains form errors
  if (newPanel && newPanel.querySelector('.ld-form-banner--error')) {
    setNewVisible(true);
  }

  // ---------- Addresses: edit existing ----------
  root.querySelectorAll('[data-ld-edit-address]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-ld-edit-address');
      var panel = root.querySelector('#ldEditAddress' + id);
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (open) {
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        panel.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  root.querySelectorAll('[data-ld-cancel-edit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-ld-cancel-edit');
      var panel = root.querySelector('#ldEditAddress' + id);
      var trigger = root.querySelector('[data-ld-edit-address="' + id + '"]');
      if (panel) panel.setAttribute('hidden', '');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });
  // Auto-open any edit panel that contains form errors
  root.querySelectorAll('.ld-address__edit').forEach(function (panel) {
    if (panel.querySelector('.ld-form-banner--error')) {
      panel.removeAttribute('hidden');
      var id = panel.id.replace('ldEditAddress', '');
      var trigger = root.querySelector('[data-ld-edit-address="' + id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
  });

  // ---------- Delete address confirm ----------
  root.querySelectorAll('[data-ld-confirm]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var msg = btn.getAttribute('data-ld-confirm');
      if (!window.confirm(msg)) {
        e.preventDefault();
      }
    });
  });

  // ---------- Country / province selectors (uses Shopify global) ----------
  if (window.Shopify && typeof Shopify.CountryProvinceSelector === 'function') {
    root.querySelectorAll('select[name="address[country]"]').forEach(function (countrySel) {
      var form = countrySel.closest('form');
      if (!form) return;
      var provSel = form.querySelector('select[name="address[province]"]');
      if (!provSel) return;
      if (countrySel.id && provSel.id) {
        try {
          new Shopify.CountryProvinceSelector(countrySel.id, provSel.id, {
            hideElement: provSel.parentElement
          });
        } catch (err) { /* fail open */ }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lootdrop-cart"]) return;
  try {
    
(function () {
  var root = document.querySelector('.ld-cart');
  if (!root || root.dataset.ldBound === '1') return;
  root.dataset.ldBound = '1';

  var form = root.querySelector('#ldCartForm');
  if (!form) return; // empty cart — nothing to bind

  var subtotalEls   = root.querySelectorAll('[data-subtotal], [data-subtotal-inline]');
  var totalEl       = root.querySelector('[data-total]');
  var itemCountEl   = root.querySelector('[data-item-count]');

  function formatMoney(cents) {
    // Shopify renders amounts in cents; we keep the locale formatting Shopify provided server-side
    // by re-using the rendered string from /cart/update.js where possible.
    // Fallback: simple CR colon formatting.
    var n = Math.round(cents);
    var withSep = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '₡' + withSep;
  }

  var pendingTimers = {};
  var inflight = null;

  function setRowLoading(key, loading) {
    var row = root.querySelector('.ld-cart-item[data-item-key="' + key + '"]');
    if (!row) return;
    var qty = row.querySelector('.ld-cart-qty');
    if (qty) qty.setAttribute('data-loading', loading ? 'true' : 'false');
  }

  function updateShipProgress(totalCents) {
    var wrap = root.querySelector('[data-ship-threshold]');
    if (!wrap) return;
    var threshold = parseInt(wrap.getAttribute('data-ship-threshold'), 10) || 0;
    if (threshold <= 0) return;
    var fill = wrap.querySelector('[data-ship-fill]');
    var msg = wrap.querySelector('[data-ship-msg]');
    var pct = Math.min(100, (totalCents / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      msg.innerHTML = totalCents >= threshold
        ? '🎉 ¡Tenés envío gratis!'
        : 'Te faltan <strong class="tabular">' + formatMoney(threshold - totalCents) + '</strong> para envío gratis';
    }
    var calc = root.querySelector('[data-ship-calc]');
    if (calc) {
      calc.innerHTML = totalCents >= threshold
        ? '<strong class="ld-ship-free">Gratis</strong>'
        : '<span class="ld-cart-summary__ship-calc">Se calcula al pagar</span>';
    }
  }

  function applyCartResponse(cart) {
    // Update grand totals
    if (totalEl && cart.total_price != null) totalEl.textContent = formatMoney(cart.total_price);
    if (cart.total_price != null) updateShipProgress(cart.total_price);
    subtotalEls.forEach(function (el) {
      if (cart.items_subtotal_price != null) el.textContent = formatMoney(cart.items_subtotal_price);
    });
    if (itemCountEl && cart.item_count != null) itemCountEl.textContent = cart.item_count;

    // Update each visible line's price + quantity
    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        var row = root.querySelector('.ld-cart-item[data-item-key="' + item.key + '"]');
        if (!row) return;
        var priceEl = row.querySelector('[data-line-price]');
        if (priceEl && item.final_line_price != null) priceEl.textContent = formatMoney(item.final_line_price);
        var qtyInput = row.querySelector('.qty-input');
        if (qtyInput && Number(qtyInput.value) !== item.quantity) qtyInput.value = item.quantity;
      });
    }

    // If item_count is 0, reload so the empty-state branch renders cleanly
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  function postUpdate(key, qty) {
    if (inflight) {
      try { inflight.abort(); } catch (_) {}
    }
    setRowLoading(key, true);

    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    inflight = ctrl;

    var body = { updates: {} };
    body.updates[key] = qty;

    var opts = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    };
    if (ctrl) opts.signal = ctrl.signal;

    fetch('/cart/update.js', opts)
      .then(function (r) {
        if (!r.ok) throw new Error('cart update failed: ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        setRowLoading(key, false);
        // If qty was 0, animate the row out before applying response
        if (qty === 0) {
          var row = root.querySelector('.ld-cart-item[data-item-key="' + key + '"]');
          if (row) {
            row.setAttribute('data-removing', 'true');
            setTimeout(function () { applyCartResponse(cart); }, 280);
            return;
          }
        }
        applyCartResponse(cart);
      })
      .catch(function (err) {
        setRowLoading(key, false);
        if (err && err.name === 'AbortError') return;
        console.error('[ld-cart]', err);
      });
  }

  function scheduleUpdate(key, qty) {
    clearTimeout(pendingTimers[key]);
    pendingTimers[key] = setTimeout(function () {
      delete pendingTimers[key];
      postUpdate(key, qty);
    }, 300);
  }

  // ---- Stepper buttons ----
  root.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-key');
      var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
      var input = root.querySelector('.qty-input[data-key="' + key + '"]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = Math.max(0, current + step);
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && max > 0) next = Math.min(max, next);
      if (next === current) return;
      input.value = next;
      scheduleUpdate(key, next);
    });
  });

  // ---- Direct input changes ----
  root.querySelectorAll('.qty-input').forEach(function (input) {
    function commit() {
      var key = input.getAttribute('data-key');
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && max > 0) val = Math.min(max, val);
      input.value = val;
      scheduleUpdate(key, val);
    }
    input.addEventListener('blur', commit);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); commit(); input.blur(); }
    });
  });

  // ---- Remove buttons ----
  root.querySelectorAll('.ld-cart-item__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-key');
      if (!key) return;
      var input = root.querySelector('.qty-input[data-key="' + key + '"]');
      if (input) input.value = 0;
      // Immediate request — no debounce on explicit remove
      clearTimeout(pendingTimers[key]);
      delete pendingTimers[key];
      postUpdate(key, 0);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lootdrop-collection"]) return;
  try {
    
(function () {
  var root = document.querySelector('.ld-collection');
  if (!root || root.dataset.ldBound === '1') return;
  root.dataset.ldBound = '1';

  var form     = root.querySelector('#ldCollectionFilters');
  var sortSel  = root.querySelector('#ld-sort');
  var sidebar  = root.querySelector('#ldSidebar');
  var backdrop = document.getElementById('ldSidebarBackdrop');
  var openBtn  = root.querySelector('#ldFilterOpen');
  var closeBtn = root.querySelector('#ldSidebarClose');

  // ---- Sort change → submit filter form ----
  if (sortSel && form) {
    sortSel.addEventListener('change', function () { form.submit(); });
  }

  // ---- Auto-submit on filter change (debounced) ----
  if (form) {
    var t = null;
    form.addEventListener('change', function (e) {
      var tgt = e.target;
      if (!tgt) return;
      // Skip the sort select — it submits immediately above
      if (tgt.id === 'ld-sort') return;
      // Skip number inputs — they fire on every keystroke when typed; commit on blur
      if (tgt.type === 'number') return;
      clearTimeout(t);
      t = setTimeout(function () { form.submit(); }, 250);
    });
    // Number (price) inputs: submit on blur or Enter
    var numberInputs = form.querySelectorAll('input[type="number"]');
    numberInputs.forEach(function (inp) {
      inp.addEventListener('blur', function () { form.submit(); });
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); form.submit(); }
      });
    });
    form.querySelectorAll('.price-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var target = document.getElementById(chip.getAttribute('data-price-target'));
        if (target) { target.value = chip.getAttribute('data-price-val'); }
        form.submit();
      });
    });
  }

  // ---- Collapse / expand filter groups ----
  root.querySelectorAll('.filter-group > .grp-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var group = head.parentElement;
      var open = group.getAttribute('data-open') !== 'false';
      group.setAttribute('data-open', open ? 'false' : 'true');
      head.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  // ---- Mobile drawer ----
  function openDrawer() {
    if (sidebar) sidebar.setAttribute('data-open', 'true');
    if (backdrop) backdrop.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (sidebar) sidebar.removeAttribute('data-open');
    if (backdrop) backdrop.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
  }
  if (openBtn)  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lootdrop-header"]) return;
  try {
    
(function () {
  const header = document.querySelector('.ld-header');
  if (!header) return;

  const hamburger = header.querySelector('.ld-hamburger');
  const drawer = header.querySelector('.ld-mobile-drawer');
  const closeBtn = drawer ? drawer.querySelector('.ld-mob-close') : null;

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (drawer && drawer.hidden) openDrawer();
      else closeDrawer();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer && !drawer.hidden) closeDrawer();
      header.querySelectorAll('.ld-nav-item.ld-has-children .ld-nav-link[aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Dropdown toggles (click) — hover handled by CSS
  header.querySelectorAll('.ld-nav-item.ld-has-children > .ld-nav-link').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      header.querySelectorAll('.ld-nav-item.ld-has-children .ld-nav-link[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) other.setAttribute('aria-expanded', 'false');
      });
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  // Click outside to close any open dropdown
  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) {
      header.querySelectorAll('.ld-nav-item.ld-has-children .ld-nav-link[aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // -------- Toast --------
  const toastStack = document.getElementById('ldToastStack');
  const TOAST_ICONS = {
    info: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
    success: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    error: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
  };
  const TOAST_TITLES = { info: 'Aviso', success: '¡Listo!', error: 'Ups' };

  function showToast(message, type, opts) {
    if (!toastStack) return;
    type = type || 'info';
    opts = opts || {};
    const title = opts.title || TOAST_TITLES[type] || 'Aviso';
    const duration = opts.duration != null ? opts.duration : 4500;

    const el = document.createElement('div');
    el.className = 'ld-toast is-' + type;
    el.setAttribute('role', type === 'error' ? 'alert' : 'status');
    el.innerHTML =
      '<span class="ld-toast-icon" aria-hidden="true">' + (TOAST_ICONS[type] || TOAST_ICONS.info) + '</span>' +
      '<div class="ld-toast-body">' +
        '<p class="ld-toast-title"></p>' +
        '<p class="ld-toast-msg"></p>' +
      '</div>' +
      '<button type="button" class="ld-toast-close" aria-label="Cerrar">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>';
    el.querySelector('.ld-toast-title').textContent = title;
    el.querySelector('.ld-toast-msg').textContent = message;

    const dismiss = function () {
      el.classList.remove('is-open');
      setTimeout(function () { el.remove(); }, 300);
    };
    el.querySelector('.ld-toast-close').addEventListener('click', dismiss);

    toastStack.appendChild(el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    });
    if (duration > 0) setTimeout(dismiss, duration);
    return dismiss;
  }
  window.LDToast = { show: showToast };

  // -------- Cart drawer --------
  const cartTrigger = header.querySelector('.ld-cart-link');
  const cartOverlay = document.getElementById('ldCartOverlay');
  const cartDrawer = document.getElementById('ldCartDrawer');
  if (!cartTrigger || !cartOverlay || !cartDrawer) return;

  const cartList = cartDrawer.querySelector('[data-cd-list]');
  const cartEmpty = cartDrawer.querySelector('[data-cd-empty]');
  const cartFoot = cartDrawer.querySelector('[data-cd-foot]');
  const cartCountEl = cartDrawer.querySelector('[data-cd-count]');
  const cartSubtotalEl = cartDrawer.querySelector('[data-cd-subtotal]');
  const cartCloseBtn = cartDrawer.querySelector('.ld-cd-close');
  const cartBadge = header.querySelector('.ld-cart-badge');
  const cartLinkLabel = cartTrigger;

  function formatMoney(cents) {
    return '₡' + Math.round((cents || 0) / 100).toLocaleString('es-CR');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderCart(cart) {
    const count = cart.item_count || 0;
    cartCountEl.textContent = count;
    cartSubtotalEl.textContent = formatMoney(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);

    // Update header badge + aria label
    if (cartBadge) {
      if (count > 0) { cartBadge.textContent = count; cartBadge.hidden = false; }
      else { cartBadge.remove(); }
    } else if (count > 0) {
      const newBadge = document.createElement('span');
      newBadge.className = 'ld-cart-badge';
      newBadge.setAttribute('aria-hidden', 'true');
      newBadge.textContent = count;
      cartTrigger.appendChild(newBadge);
    }
    cartLinkLabel.setAttribute('aria-label', 'Carrito · ' + count + ' artículo' + (count === 1 ? '' : 's'));

    if (count === 0) {
      cartList.innerHTML = '';
      cartEmpty.hidden = false;
      cartFoot.hidden = true;
      return;
    }
    cartEmpty.hidden = true;
    cartFoot.hidden = false;

    cartList.innerHTML = cart.items.map(function (item) {
      const img = item.image
        ? '<img src="' + escapeHtml(item.image.replace(/(\.[^.\/]+)(\?.*)?$/, '_200x$1$2')) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>';
      const variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="ld-cd-item-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      return (
        '<li class="ld-cd-item" data-key="' + escapeHtml(item.key) + '">' +
          '<a class="ld-cd-item-img" href="' + escapeHtml(item.url) + '">' + img + '</a>' +
          '<div class="ld-cd-item-info">' +
            '<a class="ld-cd-item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<div class="ld-cd-qty" role="group" aria-label="Cantidad">' +
              '<button type="button" data-cd-dec aria-label="Disminuir cantidad">−</button>' +
              '<span class="ld-cd-qty-val">' + item.quantity + '</span>' +
              '<button type="button" data-cd-inc aria-label="Aumentar cantidad">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="ld-cd-item-right">' +
            '<span class="ld-cd-item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button type="button" class="ld-cd-item-remove" data-cd-remove aria-label="Eliminar">Eliminar</button>' +
          '</div>' +
        '</li>'
      );
    }).join('');
  }

  let cartFetchPromise = null;
  function fetchCart() {
    cartDrawer.classList.add('is-loading');
    cartFetchPromise = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCart(data); return data; })
      .catch(function () { /* silent */ })
      .finally(function () { cartDrawer.classList.remove('is-loading'); });
    return cartFetchPromise;
  }

  function updateLine(key, quantity) {
    cartDrawer.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (data) { renderCart(data); return data; })
      .catch(function () { /* silent */ })
      .finally(function () { cartDrawer.classList.remove('is-loading'); });
  }

  function openCart() {
    cartOverlay.hidden = false;
    cartDrawer.hidden = false;
    // double rAF so the transform transition kicks in
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        cartOverlay.classList.add('is-open');
        cartDrawer.classList.add('is-open');
      });
    });
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    cartOverlay.classList.remove('is-open');
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!cartDrawer.classList.contains('is-open')) {
        cartDrawer.hidden = true;
        cartOverlay.hidden = true;
      }
    }, 250);
  }

  cartTrigger.addEventListener('click', function (e) {
    // skip drawer if user opened in new tab via cmd/ctrl-click
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    openCart();
  });
  cartCloseBtn.addEventListener('click', closeCart);
  cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !cartDrawer.hidden) closeCart();
  });

  cartList.addEventListener('click', function (e) {
    const item = e.target.closest('.ld-cd-item');
    if (!item) return;
    const key = item.dataset.key;
    const qtyVal = item.querySelector('.ld-cd-qty-val');
    const current = parseInt(qtyVal.textContent, 10) || 0;

    if (e.target.closest('[data-cd-inc]')) { updateLine(key, current + 1); return; }
    if (e.target.closest('[data-cd-dec]')) { updateLine(key, Math.max(0, current - 1)); return; }
    if (e.target.closest('[data-cd-remove]')) { updateLine(key, 0); return; }
  });

  // -------- Add-to-cart interception --------
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    // "Buy now" buttons set a formaction with return_to=/checkout — let those go through
    const submitter = e.submitter;
    if (submitter && submitter.hasAttribute('formaction') && submitter.getAttribute('formaction').indexOf('return_to') !== -1) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    const formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { openCart(); })
      .catch(function (err) {
        const msg = (err && err.description) || 'No se pudo agregar el producto. Intentá de nuevo.';
        const isSoldOut = err && (err.status === 422 || /sold[\s-]*out|agotado|inventory|stock/i.test(err.description || err.message || ''));
        showToast(msg, 'error', { title: isSoldOut ? 'Agotado' : 'No pudimos agregarlo' });
      })
      .finally(function () { if (submitBtn) submitBtn.disabled = false; });
  });

  // Expose open hook for other sections
  window.LDCart = { open: openCart, close: closeCart, refresh: fetchCart };

  // -------- Predictive search --------
  const searchBtn = header.querySelector('.ld-search-btn');
  const searchPanel = document.getElementById('ldSearchPanel');
  if (!searchBtn || !searchPanel) return;

  const spInput = searchPanel.querySelector('[data-sp-input]');
  const spForm = searchPanel.querySelector('.ld-sp-form');
  const spClose = searchPanel.querySelector('.ld-sp-close');
  const spResults = searchPanel.querySelector('[data-sp-results]');
  const spProductList = searchPanel.querySelector('[data-sp-product-list]');
  const spPagesSection = searchPanel.querySelector('[data-sp-pages]');
  const spPageList = searchPanel.querySelector('[data-sp-page-list]');
  const spEmpty = searchPanel.querySelector('[data-sp-empty]');
  const spNoResults = searchPanel.querySelector('[data-sp-noresults]');
  const spNoResultsQ = searchPanel.querySelector('[data-sp-noresults-q]');
  const spViewAll = searchPanel.querySelector('[data-sp-viewall]');

  function openSearch() {
    searchPanel.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { searchPanel.classList.add('is-open'); });
    });
    searchPanel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { spInput.focus(); }, 50);
  }
  function closeSearch() {
    searchPanel.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!searchPanel.classList.contains('is-open')) searchPanel.hidden = true;
    }, 220);
  }

  searchBtn.addEventListener('click', function (e) {
    e.preventDefault();
    openSearch();
  });
  spClose.addEventListener('click', closeSearch);
  searchPanel.addEventListener('click', function (e) {
    if (e.target === searchPanel) closeSearch();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !searchPanel.hidden) closeSearch();
  });

  function renderProducts(products) {
    if (!products || !products.length) { spProductList.innerHTML = ''; return false; }
    spProductList.innerHTML = products.map(function (p) {
      const img = p.image
        ? '<img src="' + escapeHtml(p.image.replace(/(\.[^.\/]+)(\?.*)?$/, '_120x$1$2')) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
        : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>';
      const meta = p.vendor || (p.product_type || '');
      const priceHTML = (p.compare_at_price_max && p.compare_at_price_max > p.price_max)
        ? '<span class="ld-sp-price">' + formatMoney(p.price_max) + '</span><span class="ld-sp-price was">' + formatMoney(p.compare_at_price_max) + '</span>'
        : '<span class="ld-sp-price">' + formatMoney(p.price_max) + '</span>';
      return (
        '<li><a class="ld-sp-item" href="' + escapeHtml(p.url) + '">' +
          '<span class="ld-sp-thumb">' + img + '</span>' +
          '<span class="ld-sp-itext">' +
            '<span class="ld-sp-title">' + escapeHtml(p.title) + '</span>' +
            (meta ? '<span class="ld-sp-meta">' + escapeHtml(meta) + '</span>' : '') +
          '</span>' +
          '<span class="ld-sp-pricewrap">' + priceHTML + '</span>' +
        '</a></li>'
      );
    }).join('');
    return true;
  }

  function renderPages(pages) {
    if (!pages || !pages.length) { spPagesSection.hidden = true; spPageList.innerHTML = ''; return false; }
    spPagesSection.hidden = false;
    spPageList.innerHTML = pages.map(function (pg) {
      return (
        '<li><a class="ld-sp-item" href="' + escapeHtml(pg.url) + '">' +
          '<span class="ld-sp-thumb"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></span>' +
          '<span class="ld-sp-itext"><span class="ld-sp-title">' + escapeHtml(pg.title) + '</span></span>' +
        '</a></li>'
      );
    }).join('');
    return true;
  }

  function setQueryState(state) {
    spResults.hidden = state !== 'results';
    spEmpty.hidden = state !== 'empty';
    spNoResults.hidden = state !== 'none';
  }

  let searchAbort = null;
  let searchTimer = null;

  function runSearch(q) {
    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();
    const url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,page,article'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,vendor,product_type,variants.title';

    fetch(url, { signal: searchAbort.signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        const pages = (data.resources && data.resources.results && data.resources.results.pages) || [];
        const articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
        const hasProducts = renderProducts(products);
        const hasPages = renderPages(pages.concat(articles));
        if (hasProducts || hasPages) {
          spViewAll.href = '/search?q=' + encodeURIComponent(q);
          setQueryState('results');
        } else {
          spNoResultsQ.textContent = q;
          setQueryState('none');
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
      });
  }

  spInput.addEventListener('input', function () {
    const q = spInput.value.trim();
    if (searchTimer) clearTimeout(searchTimer);
    if (!q) { setQueryState('empty'); return; }
    searchTimer = setTimeout(function () { runSearch(q); }, 220);
  });

  spForm.addEventListener('submit', function (e) {
    if (!spInput.value.trim()) e.preventDefault();
  });

  window.LDSearch = { open: openSearch, close: closeSearch };

  // -------- Auth modal (login + register) --------
  const accountLink = header.querySelector('.ld-account-link');
  const authOverlay = document.getElementById('ldAuthOverlay');
  const authModal = document.getElementById('ldAuthModal');
  if (!accountLink || !authOverlay || !authModal) return;

  const authTabs = authModal.querySelectorAll('.ld-am-tab');
  const authPanes = authModal.querySelectorAll('.ld-am-pane');
  const authClose = authModal.querySelector('.ld-am-close');

  function openAuth(tab) {
    authOverlay.hidden = false;
    authModal.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        authOverlay.classList.add('is-open');
        authModal.classList.add('is-open');
      });
    });
    document.body.style.overflow = 'hidden';
    setAuthTab(tab || 'login');
    const firstInput = authModal.querySelector('.ld-am-pane:not([hidden]) input');
    if (firstInput) setTimeout(function () { firstInput.focus(); }, 80);
  }
  function closeAuth() {
    authOverlay.classList.remove('is-open');
    authModal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!authModal.classList.contains('is-open')) {
        authModal.hidden = true;
        authOverlay.hidden = true;
      }
    }, 220);
  }
  function setAuthTab(name) {
    authTabs.forEach(function (t) {
      const active = t.dataset.tab === name;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    authPanes.forEach(function (p) {
      p.hidden = p.dataset.pane !== name;
    });
  }

  accountLink.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    openAuth('login');
  });
  authClose.addEventListener('click', closeAuth);
  authOverlay.addEventListener('click', closeAuth);
  authTabs.forEach(function (t) {
    t.addEventListener('click', function () { setAuthTab(t.dataset.tab); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !authModal.hidden) closeAuth();
  });

  // If server-rendered with form errors, open the modal automatically
  if (authModal.querySelector('.ld-am-error')) {
    const erroredPane = authModal.querySelector('.ld-am-error').closest('.ld-am-pane');
    openAuth(erroredPane ? erroredPane.dataset.pane : 'login');
  }

  window.LDAuth = { open: openAuth, close: closeAuth };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lootdrop-home-newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Newsletter optimistic UI — scoped to .ld-home forms only
  var forms = document.querySelectorAll('.ld-home form[data-ld-newsletter]');
  if (!forms.length) return;
  forms.forEach(function(form){
    if (form.dataset.ldBound === '1') return;
    form.dataset.ldBound = '1';
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('.btn');
      if (input) input.value = '';
      if (btn) btn.textContent = '¡Listo!';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lootdrop-product"]) return;
  try {
    
(function(){
  var root = document.querySelector('.ld-pdp');
  if (!root || root.dataset.ldBound === '1') return;
  root.dataset.ldBound = '1';

  var jsonNode = root.querySelector('#ldProductJson');
  var productData = null;
  try { productData = jsonNode ? JSON.parse(jsonNode.textContent) : null; } catch (e) { productData = null; }

  var mfNode = root.querySelector('#ldShopMoneyFormat');
  var moneyFormat = (window.Shopify && window.Shopify.money_format) || (mfNode ? JSON.parse(mfNode.textContent) : '');
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var value = (cents / 100);
    // Match Shopify's money_without_trailing_zeros for CRC-style output: use locale fallback.
    var hasDecimals = value !== Math.floor(value);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-CR', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CRC',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return '₡' + value.toLocaleString('es-CR', { maximumFractionDigits: hasDecimals ? 2 : 0 });
    }
  }

  // ---------- Thumbnail rail → swap main media ----------
  var thumbs = root.querySelectorAll('.thumb-rail .thumb');
  var mainImg = root.querySelector('#ldMainMedia');
  function activateThumb(thumb) {
    if (!thumb) return;
    thumbs.forEach(function(t){
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    thumb.classList.add('is-active');
    thumb.setAttribute('aria-selected', 'true');
    if (mainImg) {
      var large = thumb.dataset.large;
      var srcset = thumb.dataset.srcset;
      var alt = thumb.dataset.alt;
      if (large) {
        mainImg.style.opacity = '.5';
        var preload = new Image();
        preload.onload = function(){
          mainImg.src = large;
          if (srcset) mainImg.srcset = srcset;
          if (alt) mainImg.alt = alt;
          mainImg.style.opacity = '1';
        };
        preload.src = large;
      }
    }
  }
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){ activateThumb(t); });
  });

  // ---------- Quantity stepper ----------
  var qtyInput = root.querySelector('#ldQty');
  root.querySelectorAll('.qty button[data-step]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (!qtyInput) return;
      var step = parseInt(btn.dataset.step, 10) || 0;
      var current = parseInt(qtyInput.value, 10) || 1;
      var max = parseInt(qtyInput.max, 10) || 99;
      var min = parseInt(qtyInput.min, 10) || 1;
      var next = Math.max(min, Math.min(max, current + step));
      qtyInput.value = next;
    });
  });
  if (qtyInput) {
    qtyInput.addEventListener('change', function(){
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      var max = parseInt(qtyInput.max, 10) || 99;
      if (v > max) v = max;
      qtyInput.value = v;
    });
  }

  // ---------- Variant chip handling ----------
  var form = root.querySelector('#ldProductForm');
  var variantInput = root.querySelector('[data-ld-variant-id]');
  var priceEl = root.querySelector('[data-ld-price]');
  var compareEl = root.querySelector('[data-ld-compare]');
  var saveEl = root.querySelector('[data-ld-save]');
  var atcBtn = root.querySelector('[data-ld-atc]');
  var atcLabel = root.querySelector('[data-ld-atc-label]');
  var buyNowBtn = root.querySelector('.buy-now');
  var priceBlock = root.querySelector('.price-block');

  function readSelectedOptions() {
    var groups = root.querySelectorAll('.opt-group');
    var values = [];
    groups.forEach(function(g){
      var idx = parseInt(g.dataset.optionIndex, 10);
      var checked = g.querySelector('input[type="radio"]:checked');
      values[idx] = checked ? checked.value : null;
    });
    return values;
  }
  function findVariant(values) {
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function(v){
      var opts = [v.option1, v.option2, v.option3];
      for (var i = 0; i < values.length; i++) {
        if (values[i] != null && opts[i] !== values[i]) return false;
      }
      return true;
    }) || null;
  }
  function updatePriceUi(variant) {
    if (!variant) return;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (!compareEl && priceBlock) {
        compareEl = document.createElement('span');
        compareEl.className = 'was tabular';
        compareEl.setAttribute('data-ld-compare', '');
        priceBlock.insertBefore(compareEl, priceBlock.querySelector('.save') || null);
      }
      if (compareEl) compareEl.textContent = formatMoney(variant.compare_at_price);
      var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      if (!saveEl && priceBlock) {
        saveEl = document.createElement('span');
        saveEl.className = 'save';
        saveEl.setAttribute('data-ld-save', '');
        priceBlock.appendChild(saveEl);
      }
      if (saveEl) saveEl.textContent = '-' + pct + '%';
    } else {
      if (compareEl) { compareEl.remove(); compareEl = null; }
      if (saveEl) { saveEl.remove(); saveEl = null; }
    }
  }
  function updateAtc(variant) {
    if (!atcBtn) return;
    var available = variant && variant.available;
    atcBtn.disabled = !available;
    if (buyNowBtn) buyNowBtn.disabled = !available;
    if (atcLabel) {
      atcLabel.textContent = available
        ? ('Agregar al carrito · ' + formatMoney(variant.price))
        : 'Agotado';
    }
  }
  function updateStock(variant) {
    var stockRow = root.querySelector('[data-ld-stock]');
    if (!stockRow || !variant) return;
    if (variant.available) {
      stockRow.classList.remove('out');
      stockRow.innerHTML = '<span class="dot" aria-hidden="true"></span><strong>En stock</strong>';
      if (typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0 && variant.inventory_quantity < 10) {
        stockRow.innerHTML += '<span>· Quedan ' + variant.inventory_quantity + ' unidades</span>';
      }
    } else {
      stockRow.classList.add('out');
      stockRow.innerHTML = '<span class="dot" aria-hidden="true"></span><strong>Agotado</strong>';
    }
  }
  function updateUrl(variantId) {
    if (!variantId) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* no-op */ }
  }
  function updateMediaForVariant(variant) {
    if (!variant || !variant.featured_media || !variant.featured_media.id) return;
    var matchingThumb = root.querySelector('.thumb-rail .thumb[data-media-id="' + variant.featured_media.id + '"]');
    if (matchingThumb) activateThumb(matchingThumb);
  }

  function onOptionChange(grp, chosenLabel) {
    // toggle chip styling within this group
    grp.querySelectorAll('.opt-chip').forEach(function(c){
      c.classList.toggle('is-active', c === chosenLabel);
    });
    var pickedEl = grp.querySelector('[data-ld-selected]');
    if (pickedEl) {
      var input = chosenLabel.querySelector('input[type="radio"]');
      pickedEl.textContent = '· ' + (input ? input.value : '');
    }
    var values = readSelectedOptions();
    var variant = findVariant(values);
    if (!variant) {
      if (atcBtn) atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'No disponible';
      return;
    }
    if (variantInput) variantInput.value = variant.id;
    updatePriceUi(variant);
    updateAtc(variant);
    updateStock(variant);
    updateUrl(variant.id);
    updateMediaForVariant(variant);
  }

  root.querySelectorAll('.opt-group').forEach(function(grp){
    grp.querySelectorAll('.opt-chip').forEach(function(label){
      label.addEventListener('click', function(e){
        // Let the radio actually receive the click via the label.
        // Use a microtask to read the post-click state.
        setTimeout(function(){ onOptionChange(grp, label); }, 0);
      });
    });
  });

  // ---------- Tabs ----------
  var tabBtns = root.querySelectorAll('.tab-btn');
  tabBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      tabBtns.forEach(function(b){ b.setAttribute('aria-selected', 'false'); });
      btn.setAttribute('aria-selected', 'true');
      root.querySelectorAll('.tab-panel').forEach(function(p){
        p.dataset.active = 'false';
        p.hidden = true;
      });
      var target = root.querySelector('#' + btn.dataset.target);
      if (target) { target.dataset.active = 'true'; target.hidden = false; }
    });
    btn.addEventListener('keydown', function(e){
      var arr = Array.prototype.slice.call(tabBtns);
      var i = arr.indexOf(btn);
      if (e.key === 'ArrowRight') { e.preventDefault(); arr[(i+1)%arr.length].focus(); arr[(i+1)%arr.length].click(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); arr[(i-1+arr.length)%arr.length].focus(); arr[(i-1+arr.length)%arr.length].click(); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lootdrop-search"]) return;
  try {
    
(function () {
  var root = document.querySelector('.ld-search');
  if (!root || root.dataset.ldBound === '1') return;
  root.dataset.ldBound = '1';

  var input = root.querySelector('#ldSearchInput');
  var clear = root.querySelector('.ld-search__clear');
  var form  = root.querySelector('#ldSearchForm');

  // Auto-focus the input only if it's empty (avoid stealing focus when user lands on a results page)
  if (input && !input.value) {
    try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }
  }

  // Clear button: reset the field, refocus, then let the link navigate to /search
  // (we still navigate because the URL contains the cached query; this is a progressive enhancement)
  if (clear && input) {
    clear.addEventListener('click', function () {
      input.value = '';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
